if (!customElements.get('dt-callback-form')) {
  customElements.define('dt-callback-form', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const palette = { ink: '#292823', line: '#cfc3b2', surface: '#fffdf9', button: '#2c2a25', buttonText: '#fff8ed', radius: '4px' };
      // Use Hulk Form Builder's existing theme-settings bridge for iframe embeds.
      {
        const formId = this.querySelector('.pxFormGenerator[id]')?.id;
        if (formId) {
          // The embedded form's saved CSS uses !important in this same layer.
          
          const frameStyles = `@layer utilities {
            html body { color:${palette.ink}!important; font-family:Helvetica,Arial,sans-serif!important; }
            html body #formGeneratorForm .block_label { color:#3d3830!important; }
            html body #formGeneratorForm :is(input.form-control,select.form-control,textarea.form-control) {
              background:${palette.surface}!important; color:${palette.ink}!important;
              border:1px solid ${palette.line}!important; border-radius:4px!important;
              font-family:Helvetica,Arial,sans-serif!important;
              min-height:52px!important; width:100%!important; padding:12px 14px!important; font-size:16px!important;
            }
            html body #formGeneratorForm select { height:52px!important; appearance:auto!important; padding-right:30px!important; }
            html body #formGeneratorForm input::placeholder { color:#8a8073!important; }
            html body #formGeneratorForm button[type=submit] {
              background:${palette.button}!important; color:${palette.buttonText}!important;
              border:1px solid ${palette.button}!important; border-radius:4px!important;
              font-family:Helvetica,Arial,sans-serif!important;
            }
            html body #formGeneratorForm :is(input,select,textarea,button):focus-visible {
              outline:2px solid #96754d!important; outline-offset:-2px!important; box-shadow:none!important;
            }
            html body #formGeneratorForm :is(input,select,textarea):focus { border-color:#96754d!important; }
            html body #formGeneratorForm :is(input,select,textarea)[aria-invalid=true],
            html body #formGeneratorForm :is(input,select,textarea).error { border-color:#a12d3a!important; }
          }`;
          window.FbThemeAppExtSettingsHash = {
            ...(window.FbThemeAppExtSettingsHash || {}),
            [formId]: {
              ...(window.FbThemeAppExtSettingsHash?.[formId] || {}),
              form_uuid: formId, form_settings: 'true',
              fill_color: 'transparent', padding: 0, border: 0,
              border_color: 'transparent', border_radius: 0, form_width: 1000,
              fonts: 'Helvetica, Arial, sans-serif', font_color: '#3d3830', size: 13,
              btn_text: this.dataset.submitLabel,
              sub_btn_bg_color: palette.button, sub_btn_txt_color: palette.buttonText,
              sub_btn_bdr_rad: 4, sub_btn_font_size: 15,
              sub_btn_bdr_width: 1, sub_btn_bdr_color: palette.button,
              input_font_color: palette.ink, input_size: 16,
              input_background_color: palette.surface,
              input_border_radius: 4, input_border_color: palette.line,
              input_background_color_focus: `${palette.surface}!important; } ${frameStyles} .hulk_form_${formId} input:focus { background:${palette.surface}`,
              input_border_color_focus: '#96754d'
            }
          };
        }
      }
      const services = {
        trico: 'Tricopigmentation capillaire', emsculpt: 'EMSCULPT',
        reparatrice: 'Dermopigmentation réparatrice', esthetique: 'Dermopigmentation esthétique',
        taches: 'Dermopigmentation des taches de rousseur', blanchiment: 'Blanchiment dentaire'
      };
      const params = new URLSearchParams(location.search);
      const requestedService = params.get('prestation') || params.get('consultation');
      const serviceKey = ['body', 'body-sculpt', 'bodysculpt'].includes(requestedService) ? 'emsculpt' : requestedService;
      const queryService = services[serviceKey];
      const messages = new Map([
        ['Nom et prénom is required', this.dataset.errorName],
        ['Numéro de téléphone is required', this.dataset.errorPhone],
        ['Prestation souhaitée is required', this.dataset.errorService]
      ]);
      const enhance = () => {
        this.querySelectorAll('[role="alert"] p').forEach(error => {
          const translation = messages.get(error.textContent.trim().replace(/\s+/g, ' '));
          if (translation) { error.textContent = translation; error.setAttribute('aria-label', translation); }
        });
        const close = this.querySelector('[role="alert"] button[aria-label="Close"]');
        if (close) close.setAttribute('aria-label', this.dataset.errorClose);
        const form = this.querySelector('form');
        if (!form) return;
        const setStyles = (element, styles) => {
          if (!element) return;
          for (const [property, value] of Object.entries(styles)) {
            if (element.style.getPropertyValue(property) !== value || element.style.getPropertyPriority(property) !== 'important') element.style.setProperty(property, value, 'important');
          }
        };
        this.querySelectorAll('.pxFormGenerator, #formGeneratorForm, .form_generater_form_div, .form_container').forEach(element => {
          setStyles(element, { background: 'transparent', border: '0', padding: '0', margin: '0', width: '100%', 'max-width': 'none', 'box-shadow': 'none' });
        });
        const name = form.querySelector('input[name="Nom et prénom"]');
        const phone = form.querySelector('input[name="Numéro de téléphone"]');
        if (name) name.autocomplete = 'name';
        if (phone) {
          phone.type = 'tel'; phone.inputMode = 'tel'; phone.autocomplete = 'tel';
          phone.removeAttribute('min'); phone.removeAttribute('max'); phone.removeAttribute('step');
        }
        form.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), select, textarea').forEach(control => {
          setStyles(control, { background: palette.surface, color: palette.ink, border: control.getAttribute('aria-invalid') === 'true' ? '1px solid #a12d3a' : '1px solid ' + palette.line, 'border-radius': palette.radius, 'font-size': '16px', 'letter-spacing': 'normal', 'min-height': '52px', width: '100%', padding: '12px 14px', 'box-shadow': 'none' });
        });
        const select = form.querySelector('select[name="Prestation souhaitée"]');
        const bodyOption = select && Array.from(select.options).find(option => option.value === 'EMSCULPT');
        if (bodyOption && this.dataset.bodyLabel && bodyOption.textContent.trim() !== this.dataset.bodyLabel) {
          bodyOption.textContent = this.dataset.bodyLabel;
        }
        if (select && !this.preselected) {
          const label = this.dataset.service || queryService;
          const option = Array.from(select.options).find(option => option.textContent.trim() === label || option.value === label);
          if (option) {
            this.preselected = true;
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (!label) {
            this.preselected = true;
          }
        }
        if (name && phone && select && !form.dataset.dtCallbackValidationReady) {
          form.dataset.dtCallbackValidationReady = 'true';
          const fields = [
            { control: name, message: this.dataset.errorName },
            { control: phone, message: this.dataset.errorPhone },
            { control: select, message: this.dataset.errorService }
          ];
          let attempted = false;
          const validate = field => {
            const control = field.control;
            const group = control.closest('.form-group');
            if (!group) return true;
            const message = control.value.trim() ? '' : field.message;
            let error = group.querySelector('.dt-callback__field-error');
            if (!error && message) {
              error = document.createElement('p');
              error.className = 'dt-callback__field-error';
              error.id = control.id + '-callback-error';
              error.setAttribute('aria-live', 'polite');
              group.append(error);
            }
            if (error) {
              if (error.textContent !== message) error.textContent = message;
              error.hidden = !message;
              const descriptions = new Set((control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
              if (message) {
                descriptions.add(error.id);
                control.setAttribute('aria-invalid', 'true');
              } else {
                descriptions.delete(error.id);
                control.removeAttribute('aria-invalid');
              }
              if (descriptions.size) control.setAttribute('aria-describedby', [...descriptions].join(' '));
              else control.removeAttribute('aria-describedby');
            }
            setStyles(control, { border: message ? '1px solid #a12d3a' : '1px solid ' + palette.line });
            return !message;
          };
          const guard = event => {
            if (event.type === 'click' && !event.target.closest('button[type="submit"]')) return;
            attempted = true;
            const invalid = fields.filter(field => !validate(field));
            if (!invalid.length) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            invalid[0].control.focus();
          };
          form.addEventListener('click', guard, true);
          form.addEventListener('submit', guard, true);
          fields.forEach(field => {
            const update = () => { if (attempted) validate(field); };
            field.control.addEventListener('input', update);
            field.control.addEventListener('change', update);
          });
        }
        const submit = form.querySelector('button[type="submit"]');
        setStyles(submit, { background: palette.button, color: palette.buttonText, border: '1px solid ' + palette.button, 'border-radius': palette.radius, width: '100%', 'min-height': '54px', padding: '14px 16px', 'font-size': '15px', 'font-weight': '600', 'letter-spacing': 'normal', 'text-transform': 'none' });
        const text = submit && !submit.disabled && Array.from(submit.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (text && text.textContent !== this.dataset.submitLabel) text.textContent = this.dataset.submitLabel;
      };
      this.observer = new MutationObserver(enhance);
      this.observer.observe(this, { childList: true, characterData: true, subtree: true });
      enhance();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.observer = null; }
  });
}




